import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useMemo, useState, useEffect } from "react";
import { axiosReq } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
const AddModalTeacher = ({ setShowModal, title, buttonName,
     setRecheck, reCheck, data
     , setSettingModal,setData }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();
    const initialAssignment = data?.academicAssignments?.[0];
    const [collegeFields, setCollegeFields] = useState([]);
    const [selectedCollegeId, setSelectedCollegeId] = useState(initialAssignment?.collegeId ? String(initialAssignment.collegeId) : "");


    const suggestedEmailForReview = !data?.email ? (data?.suggestedEmail || '') : '';
    const isSuggestedEmailReview = Boolean(suggestedEmailForReview);
    const [allValues, setAllValues] = useState({
        Name: data ? data.name : '',
        Family: data ? data.family : '',
        Username: data?.email || suggestedEmailForReview, SuggestedEmail: data?.suggestedEmail || '',
        AcademicTitle: data?.academicTitle || '', Department: data?.department || '',
        OfficialPageUrl: data?.officialPageUrl || '', SourceUrl: data?.sourceUrl || '',
        ResearchAreas: data?.researchAreas || '', RecentWorks: data?.recentWorks || '',
        LastValidatedAt: data?.lastValidatedAt ? data.lastValidatedAt.slice(0, 10) : '',
        EmailVerificationStatus: data?.email
            ? (data?.emailVerificationStatus || 'OfficialUnverified')
            : isSuggestedEmailReview ? 'OfficialUnverified' : 'Missing',
        IsActive: Boolean(data?.email || suggestedEmailForReview),
        AcademicAssignmentCollegeFieldIds: Array.isArray(data?.academicAssignments)
            ? data.academicAssignments.map((item) => String(item.collegeFieldId)) : []
    });

    useEffect(() => {
        axiosReq("CollegeField/GetCollegeFields", "get").then((result) =>
            setCollegeFields(Array.isArray(result) ? result : []));
    }, []);

    const collegeOptions = useMemo(() => {
        const unique = new Map();
        collegeFields.forEach((item) => {
            if (item?.college) unique.set(item.college.collegeId, item.college);
        });
        return [...unique.values()].sort((a, b) => a.name.localeCompare(b.name));
    }, [collegeFields]);
    const fieldOptions = useMemo(() => collegeFields.filter((item) =>
        String(item.collegeId) === String(selectedCollegeId)), [collegeFields, selectedCollegeId]);
    const [allValuesError, setAllValuesError] = useState({
        Name: false,
        Family: false,
        Username: false,
        Password: false

    });
    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }


        }

    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value, ...(e.target.name === "Username" ? {
                EmailVerificationStatus: e.target.value ? (allValues.EmailVerificationStatus === "Missing" ? "OfficialUnverified" : allValues.EmailVerificationStatus) : "Missing",
                IsActive: Boolean(e.target.value), LastValidatedAt: e.target.value ? (allValues.LastValidatedAt || new Date().toISOString().slice(0, 10)) : ""
            } : {}) })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addAdmin();
        }
    };


    const addAdmin = async () => {
        let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

        setSnipper(true)


       
        var res = allFull(allValues)
        console.log(res)
        if (res) {
            const dataUser = await axiosReq("Teacher/InsertTeacher", "post", {
                Name: allValues?.Name,
                Family: allValues?.Family,
                Email: allValues?.Username || null, SuggestedEmail: allValues.SuggestedEmail || null,
                AcademicTitle: allValues.AcademicTitle, Department: allValues.Department,
                OfficialPageUrl: allValues.OfficialPageUrl, SourceUrl: allValues.SourceUrl,
                ResearchAreas: allValues.ResearchAreas, RecentWorks: allValues.RecentWorks,
                LastValidatedAt: allValues.LastValidatedAt || null, EmailVerificationStatus: allValues.EmailVerificationStatus,
                IsActive: allValues.IsActive,
                AcademicAssignmentCollegeFieldIds: allValues.AcademicAssignmentCollegeFieldIds.map(Number),

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)
                setShowModal(false)
                setData(dataUser?.data)
                // setSettingModal(true)
                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");

            }
            else {
                console.log(allValuesError)
                setEroor(dataUser?.data)

                setShowErrorModalStep1(true);
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

        
    }
    }
    const editAdmin = async () => {
        let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

        setSnipper(true)


      
        setSnipper(true)
        var res = allFull(allValues)
        console.log(res)
        if (res) {
            const dataUser = await axiosReq("Teacher/UpdateTeacher", "put", {
                TeacherId: data?.teacherId,
                Name: allValues?.Name,
                Family: allValues?.Family,
                Email: allValues?.Username || null, SuggestedEmail: allValues.SuggestedEmail || null,
                AcademicTitle: allValues.AcademicTitle, Department: allValues.Department,
                OfficialPageUrl: allValues.OfficialPageUrl, SourceUrl: allValues.SourceUrl,
                ResearchAreas: allValues.ResearchAreas, RecentWorks: allValues.RecentWorks,
                LastValidatedAt: allValues.LastValidatedAt || null, EmailVerificationStatus: allValues.EmailVerificationStatus,
                IsActive: allValues.IsActive,
                AcademicAssignmentCollegeFieldIds: allValues.AcademicAssignmentCollegeFieldIds.map(Number),

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)

                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");
                setShowModal(false)
            }
            else {
                console.log(allValuesError)
                setEroor(dataUser.data);

                setShowErrorModalStep1(true);
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

        }
    }
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "" && ["Name", "Family"].includes(o)) {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
            // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
            //     updatedState[o] = true;


            //     setAllValuesError({ ...allValuesError, ...updatedState })
            //     result = false;
            // }

        }
        console.log(allValuesError)
        return result
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[50%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام</span>
                                <input
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    name="Name"
                                    placeholder="نام را اینجا بنویسید"
                                    value={allValues?.Name}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" />
                                       {
                                    allValuesError.Name ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col"><span className="text-[13px] font-IRANYekanBold mb-1">دانشکده</span><select className="h-[35px] border-[1px] border-borderGray text-[12px] px-[10px] rounded-[5px]" value={selectedCollegeId} onChange={(event) => { setSelectedCollegeId(event.target.value); setAllValues((current) => ({ ...current, AcademicAssignmentCollegeFieldIds: [] })); }}><option value="">بدون دانشکده</option>{collegeOptions.map((college) => <option key={college.collegeId} value={college.collegeId}>{college.name}</option>)}</select></div>
                            <div className="col-span-1 mb-[10px] flex flex-col"><span className="text-[13px] font-IRANYekanBold mb-1">رشته</span><select multiple disabled={!selectedCollegeId} className="min-h-[70px] border-[1px] border-borderGray text-[12px] p-[7px] rounded-[5px] disabled:bg-gray-100" value={allValues.AcademicAssignmentCollegeFieldIds} onChange={(event) => setAllValues((current) => ({ ...current, AcademicAssignmentCollegeFieldIds: Array.from(event.target.selectedOptions, (option) => option.value) }))}>{fieldOptions.map((relation) => <option key={relation.collegeFieldId} value={relation.collegeFieldId}>{relation.field?.name || "رشته نامشخص"}</option>)}</select><small className="mt-1 text-[9px] text-gray-500">برای انتخاب چند رشته، Ctrl یا ⌘ را نگه دارید.</small></div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام خانوادگی</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="نام خانوادگی را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Family"
                                    onChange={changeHandler}
                                    value={allValues?.Family}
                                    onInput={maxLengthCheck}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    maxLength={100} />
                                     {
                                    allValuesError.Family ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام خانوادگی را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                     
                          
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">ایمیل واقعی (اختیاری)</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="email" dir="ltr" placeholder="ایمیل را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Username"
                                    onChange={changeHandler}
                                    value={allValues?.Username}
                                    onInput={maxLengthCheck}
                                    maxLength={320}
                                />
                                {isSuggestedEmailReview && <span className="mt-1 text-[10px] text-amber-700">این ایمیل توسط عامل پیشنهاد شده است؛ در صورت صحت، فقط دکمه تأیید را بزنید یا آن را ویرایش کنید.</span>}
                                {
                                    allValuesError.Username ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا ایمیل را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            {[['AcademicTitle','عنوان دانشگاهی'],['Department','دپارتمان'],['OfficialPageUrl','صفحه رسمی'],['SourceUrl','منبع اطلاعات'],['SuggestedEmail','ایمیل پیشنهادی تأییدنشده']].map(([name,label]) => <div key={name} className="col-span-1 mb-[10px] flex flex-col"><span className="text-[13px] font-IRANYekanBold mb-1">{label}</span><input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal px-[10px] rounded-[5px]" type={name.includes('Url') ? 'url' : name === 'SuggestedEmail' ? 'email' : 'text'} dir={name.includes('Url') || name === 'SuggestedEmail' ? 'ltr' : 'rtl'} name={name} value={allValues[name]} onChange={changeHandler} /></div>)}
                            <div className="col-span-2 mb-[10px] flex flex-col"><span className="text-[13px] font-IRANYekanBold mb-1">حوزه‌های پژوهشی</span><textarea className="min-h-[70px] border-[1px] border-borderGray text-[12px] font-IRANYekanNormal p-[10px] rounded-[5px]" name="ResearchAreas" value={allValues.ResearchAreas} onChange={changeHandler} placeholder="مثلاً Machine Learning, Medical Imaging" /></div>
                            <div className="col-span-2 mb-[10px] flex flex-col"><span className="text-[13px] font-IRANYekanBold mb-1">مقالات یا پروژه‌های اخیر</span><textarea className="min-h-[70px] border-[1px] border-borderGray text-[12px] font-IRANYekanNormal p-[10px] rounded-[5px]" name="RecentWorks" value={allValues.RecentWorks} onChange={changeHandler} /></div>
                            <div className="col-span-1 mb-[10px] flex flex-col"><span className="text-[13px] font-IRANYekanBold mb-1">آخرین اعتبارسنجی</span><input className="h-[35px] border-[1px] border-borderGray text-[12px] px-[10px] rounded-[5px]" type="date" name="LastValidatedAt" value={allValues.LastValidatedAt} onChange={changeHandler} /></div>
                            <div className="col-span-1 mb-[10px] flex flex-col"><span className="text-[13px] font-IRANYekanBold mb-1">وضعیت ایمیل</span><select disabled={!allValues.Username} className="h-[35px] border-[1px] border-borderGray text-[12px] px-[10px] rounded-[5px] disabled:bg-gray-100" name="EmailVerificationStatus" value={allValues.EmailVerificationStatus} onChange={changeHandler}><option value="Missing">نیازمند یافتن ایمیل</option><option value="VerifiedOfficial">رسمی تأییدشده</option><option value="OfficialUnverified">دانشگاهی تأییدنشده</option><option value="PersonalDomain">دامنه عمومی</option><option value="Invalid">نامعتبر</option><option value="Bounced">برگشتی</option></select></div>
                            <label className="col-span-2 flex items-center gap-2 text-[12px] font-IRANYekanBold"><input type="checkbox" disabled={!allValues.Username} checked={allValues.IsActive} onChange={(event) => setAllValues((current) => ({ ...current, IsActive: event.target.checked }))} />استاد فعال و قابل انتخاب باشد</label>


                        </div>
                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                            <button onClick={() => title == "ویرایش" ? editAdmin() : addAdmin()} className="min-h-[40px] min-w-[107px] px-3 bg-infinity-gradient rounded-[10px]"><p className="text-[13px] text-white font-IRANYekanBold">{isSuggestedEmailReview ? "تأیید و فعال‌سازی" : buttonName}</p></button>
                        </div>
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[50%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                            {error}
                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link

                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-infinity-gradient font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default AddModalTeacher;
